import { Injectable } from '@angular/core';
import { IStorageFactory, IStorageProvider, StorageType } from './storage-model';
import { LocalStorage } from './local-storage';
import { SessionStorage } from './session-storage';
import { HttpClient } from '@angular/common/http';
@Injectable()
class StorageFactoryService implements IStorageFactory {
  STATE_KEY = 'sac-aip-state';
  constructor(private http: HttpClient) {}

  getStorage(type: StorageType, storageKeyPrefixName?: string): any {
    let storageProvider: IStorageProvider;
    switch (type) {
      case StorageType.local:
        storageProvider = new LocalStorage(storageKeyPrefixName);
        break;
      case StorageType.session:
        storageProvider = new SessionStorage(storageKeyPrefixName);
        break;
    }
    if (!storageProvider) {
      throw new Error('Not yet implemented');
    }
    return storageProvider;
  }

  setAipSessionState(state: any): void {
    const sessionStorageProvider: IStorageProvider = this.getStorage(StorageType.session);
    sessionStorageProvider.set(this.STATE_KEY, JSON.stringify(state));
  }

  getAipSessionState(): any {
    const sessionStorageProvider: IStorageProvider = this.getStorage(StorageType.session);
    const fltrSesionState = sessionStorageProvider.get(this.STATE_KEY);
    if (fltrSesionState) {
      return JSON.parse(fltrSesionState);
    }
    return null;
  }

  clearAipSessionState(): void {
    sessionStorage.removeItem(this.STATE_KEY);
  }
}

export { IStorageFactory, StorageFactoryService };
